/**
 * Created by quikr on 9/1/16.
 */
import React from "react";

let series = new Array();
for (let i = 0; i < 30; i++) {
  series[i] = i.toString();
}
function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}

function compareNumbers(a, b) {
  return a - b;
}

var App = React.createClass({
  getInitialState: function () {
    return {
      data: this.props.data,
      series: this.props.series,

      labels: ['cats', 'dogs', 'horses', 'ducks', 'cows'],
      colors: ['#FFFFFF', '#FFFFFF', '#F2317A', '#FF9824', '#58CF6C']
    }
  },
  componentDidMount: function () {


  },
  populateArray: function () {
    var data = [[1], [2], [3]],
      series = 30,//getRandomInt(2, 10),
      serieLength = 45;//getRandomInt(2, 10);

    for (var i = series; i--;) {
      var tmp = [];

      for (var j = serieLength; j--;) {
        tmp.push(j + 2);
      }


      data.push(tmp);
    }

    this.setState({data: data});
  }, populateArrays: function () {
    var data = [],
      series = 2,//getRandomInt(2, 10),
      serieLength = 1;//getRandomInt(2, 10);

    for (var i = series; i--;) {
      var tmp = [];

      for (var j = serieLength; j--;) {
        tmp.push(getRandomInt(0, 20));
      }


      data.push(tmp);
    }

    this.setState({data: data});
  },
  render: function () {
    return (

      <div>
        <Charts

          data={ this.props.data }
          labels={ this.props.series }
          colors={ this.state.colors }
          style={{opacity: 1}}
          height={ this.props.chartHeight }
          totalHeight={this.props.height}
        />
      </div>


    );
  }
});


var Legend = React.createClass({
  render: function () {
    var labels = this.props.labels,
      colors = this.props.colors;

    return (
      <div className="Legend">
        { labels.map(function (label, labelIndex) {
          return (
            <div>
              <span className="Legend--color" style={{backgroundColor: colors[labelIndex % colors.length]}}/>
              <span className="Legend--label">{ label }</span>
            </div>
          );
        }) }
      </div>
    );
  }
});

var Charts = React.createClass({
  render: function () {
    var self = this,
      data = this.props.data,
      layered = this.props.grouping === 'layered' ? true : false,
      stacked = this.props.grouping === 'stacked' ? true : false,
      opaque = this.props.opaque,
      max = 0;

    for (var i = data.length; i--;) {
      for (var j = data[i].length; j--;) {
        if (data[i][j] > max) {
          max = data[i][j];
        }
      }
    }


    return (
      <div style={{paddingRight: '0px', paddingLeft: '0px', marginTop: '10px', height: this.props.totalHeight}}
           className={ 'Charts' + (this.props.horizontal ? ' horizontal' : '' ) }>
        { data.map(function (serie, serieIndex) {
          var sortedSerie = serie.slice(0),
            sum;
          sum = serie.reduce(function (carry, current) {
            return carry + current;
          }, 0);
          sortedSerie.sort(compareNumbers);

          return (
            <div className={ 'Charts--serie ' + (self.props.grouping) }
                 key={ serieIndex }
                 style={{height: self.props.height ? self.props.height : 'auto', marginRight: '0px'}}
            >
              <label
                style={{"font-family": '"ProximaNova-Regular", "sans-serif"'}}>{ self.props.labels[serieIndex] }</label>
              { serie.map(function (item, itemIndex) {


                var color = self.props.colors[itemIndex], style,
                  size = item / (stacked ? sum : max) * 100;

                style = {
                  backgroundColor: '#0083C7',
                  opacity: 0.75,
                  zIndex: item
                };

                if (self.props.horizontal) {
                  style['width'] = size + '%';
                } else {
                  style['height'] = size + '%';
                }

                if (layered && !self.props.horizontal) {
                  //console.log(sortedSerie, serie, sortedSerie.indexOf(item));
                  style['right'] = ((sortedSerie.indexOf(item) / (serie.length + 1)) * 100) + '%';
                  // style['left'] = (itemIndex * 10) + '%';
                }

                return (


                  <div
                    className={ 'Charts--item ' + (self.props.grouping) }
                    style={ style }
                    key={ itemIndex }
                  >
                    <b style={{color: '#212121'}}>{ item }</b>
                  </div>

                );
              }) }
            </div>
          );
        }) }
      </div>
    );
  }
});

export default App;



/** WEBPACK FOOTER **
 ** ./src/feature/attendance/charts.js
 **/